import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class FireAlarmSystemMainDto extends InspectionCase {
  safetyPlansDelivered?: InspectionValueCase;
  siteAtRisk?: InspectionValueCase;
  protectedAreas?: InspectionValueCase;
}

export class FireAlarmSystemMain extends FireAlarmSystemMainDto {
  constructor(data: FireAlarmSystemMainDto = { title: 'כללי' }) {
    super(data);
    this.safetyPlansDelivered = new InspectionValueCase({
      ...data.safetyPlansDelivered,
      title: 'תוכניות בטיחות נמסרו'
    });
    this.siteAtRisk = new InspectionValueCase({
      ...data.siteAtRisk,
      title:
        'האתר מסווג ע"י המתכנן / יועץ הבטיחות / רשות כבאות והצלה כדרגת סיכון'
    });
    this.protectedAreas = new InspectionValueCase({
      ...data.protectedAreas,
      title: 'רשימת האזורים המוגנים כפי שמופיע בתוכנית'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.safetyPlansDelivered.isApplicable ||
        this.safetyPlansDelivered.isPassed) &&
        (!this.siteAtRisk.isApplicable || this.siteAtRisk.isPassed) &&
        (!this.protectedAreas.isApplicable || this.protectedAreas.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.safetyPlansDelivered.getNotes(),
      ...this.siteAtRisk.getNotes(),
      ...this.protectedAreas.getNotes()
    ];
  }
}
